module.exports = __webpack_public_path__ + "img/party-2016-committee.4528a4a4.jpg";